export default __webpack_public_path__ + "static/media/card0.ee119341.svg";